<template>
  <time-picker
    :steps="[1, 1, 5]"
    :value="current_value"
    format="mm:ss"
    :class="classes"
    @input="input"
  />
</template>

<script>
  import { seconds_to_time, time_to_seconds } from '@shared/helpers/time';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },

      disable_hours: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        current_value: null
      };
    },

    computed: {
      classes: function() {
        return {
          'time-picker': true,
          'time-picker--disable-hours': this.disable_hours
        };
      }
    },

    watch: {
      value: {
        handler: function(value) {
          const format_value = seconds_to_time(value);

          if (format_value !== this.current_value) {
            this.current_value = format_value;
          }
        },
        immediate: true
      }
    },

    methods: {
      input(value) {
        this.$emit('input', time_to_seconds(value));
      }
    }
  };
</script>

<style lang="scss">
  .time-picker {
    &--disable-hours {
      .ivu-time-picker-cells-with-seconds {
        min-width: auto;
      }

      .ivu-time-picker-cells-list:first-child {
        display: none;
      }
    }
  }
</style>
